module.exports = __webpack_public_path__ + "img/sign-in-with-apple-left-aligned.248b45bb.svg";